export default __webpack_public_path__ + "static/media/Visual 4.ee96118b.png";